(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-article-editorial"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('es-article-reading')) {
    customElements.define('es-article-reading', class extends HTMLElement {
      connectedCallback() {
        this.headings = [...this.querySelectorAll('.es-reading__body h2, .es-reading__body h3')];
        const list = this.querySelector('.es-reading__contents ul');
        if (!list || this.headings.length < 2) return;
        if (!this.dataset.ready) {
          this.headings.forEach((heading, index) => {
            if (!heading.id) heading.id = `es-article-section-${index + 1}`;
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent;
            item.append(link);
            list.append(item);
          });
          this.dataset.ready = 'true';
        }
        this.links = [...list.querySelectorAll('a')];
        this.querySelector('.es-reading__contents').hidden = false;
        this.controller = new AbortController();
        const schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateCurrentSection();
          });
        };
        document.addEventListener('scroll', schedule, { capture: true, passive: true, signal: this.controller.signal });
        window.addEventListener('resize', schedule, { passive: true, signal: this.controller.signal });
        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(this.querySelector('.es-reading__body'));
        this.updateCurrentSection();
      }
      updateCurrentSection() {
        const header = document.querySelector('#header-component');
        const headerBottom = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, header.offsetHeight)) : 0;
        const offset = Math.ceil(headerBottom + 16);
        this.style.setProperty('--es-reading-sticky-top', `${offset}px`);
        const threshold = Math.max(offset + 40, (header?.offsetHeight || 0) + 40);
        let active = 0;
        this.headings.forEach((heading, index) => {
          if (heading.getBoundingClientRect().top <= threshold) active = index;
        });
        this.links.forEach((link, index) => {
          if (index === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
